import React from "react";
import Logo from "../assets/img/logo-light.svg";
import Image from "../assets/img/login.png";
import { Link, Redirect, Route } from 'react-router-dom'

const Register = ({ history, registerUser = (f) => f }) => {
  let _fname, _lname, _email, _phone, _password;
  
  let ref_url_raw = window.location.href;

  let ref_url = localStorage["refState"] ? JSON.parse(localStorage["refState"]).refURL : "";


  // console.log(ref_url);

  // save ref_url state in local storage
  let refState = {
    refURL: ref_url_raw
  };
  localStorage["refState"] = JSON.stringify(refState);

  const handleRegistration = (e) => {
    e.preventDefault();

    registerUser(
      _fname.value,
      _lname.value,
      _email.value,
      _phone.value,
      _password.value,
      ref_url
    );
  };

  const isLoggedIn = localStorage["appState"] ? JSON.parse(localStorage["appState"]).isLoggedIn : "";

  return (

    isLoggedIn ? (
      <Redirect to={{ pathname: '/dashboard', state: { from: '/register' } }} />
    ) : (

    <main className="login-body d-flex align-items-center min-vh-100 py-3 py-md-0">
      <div className="container">
        <div className="card login-card">
          <div className="row no-gutters">
            <div className="col-md-7">
              <img src={Image} alt="login" className="login-card-img" />
            </div>
            <div className="col-md-5">
              <div className="card-body">
                <div className="brand-wrapper">
                  <img src={Logo} alt="logo" className="logo" />
                </div>
                <p className="login-card-description">Register Account</p>
                <form id="reg" onSubmit={handleRegistration} method="post">
                  <div className="row" style={{ marginBottom: "-20px" }}>
                    <div className="form-group col">
                      <label for="firstname" className="sr-only">
                        Firstname
                      </label>
                      <input
          ref={input => (_fname = input)}
                        type="firstname"
                        name="firstname"
                        id="firstname"
                        className="form-control"
                        placeholder="Firstname"
                      />
                    </div>
                    <div className="form-group col">
                      <label for="lastname" className="sr-only">
                        Lastname
                      </label>
                      <input
          ref={input => (_lname = input)}
                        type="lastname"
                        name="lastname"
                        id="lastname"
                        className="form-control"
                        placeholder="Lastname"
                      />
                    </div>
                  </div>
                  <div className="form-group mt-3">
                    <label for="email" className="sr-only">
                      Email
                    </label>
                    <input
          ref={input => (_email = input)}
                      type="email"
                      name="email"
                      id="email"
                      className="form-control"
                      placeholder="Email address"
                    />
                  </div>
                  <div className="form-group">
                    <label for="telephone" className="sr-only">
                      Telephone
                    </label>
                    <input
          ref={input => (_phone = input)}
                      type="telephone"
                      name="telephone"
                      id="telephone"
                      className="form-control"
                      placeholder="Telephone"
                    />
                  </div>
                  <div className="form-group mb-4">
                    <label for="password" className="sr-only">
                      Password
                    </label>
                    <input
          ref={input => (_password = input)}
                      type="password"
                      name="password"
                      id="password"
                      className="form-control"
                      placeholder="password"
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn btn-block login-btn mb-4"
                    >
                    Register
                </button>
                </form>
                <p className="login-card-footer-text">
                  Already have an account?{" "}
                  <Link to="/login" className="text-reset">
                    Login
                  </Link>
                </p>
                <nav className="login-card-footer-nav">
                  <Link to="/privacy">Privacy policy</Link>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  ));
};
export default Register;
